import { TableColumnsType } from "antd";
import {
  ReportInventoryRecorderRow,
  ReportInventoryRecorderRowDetail,
} from "api/interfaces/reportInterface.interface";
import InfiniteExpandTable from "components/blocks/table/InfiniteExpandTable";
import { useMemo } from "react";

export default function InventoryExpandList({
  columns,
  data,
}: {
  columns: TableColumnsType<ReportInventoryRecorderRow>;
  data: ReportInventoryRecorderRowDetail[];
}) {
  const convertData = useMemo(() => {
    return data.map((item, index) => {
      return {
        ...item,
        mergedSystemId: item.recorderId,
        mergedSystemName: item.name,
        recorders: [item],
      };
    });
  }, [data]);
  const expandColumns = useMemo(() => {
    return columns
      .filter(
        (column) =>
          column.key !== "version" &&
          column.key !== "model" &&
          column.key !== "accountName"
      )
      .map((column) => {
        if (column.key === "type") {
          return {
            ...column,
            render: () => "",
          };
        }
        return column;
      });
  }, [columns]);
  return (
    <InfiniteExpandTable
      data={convertData}
      loadMore={() => {}}
      isLoading={false}
      hasMore={false}
      columns={expandColumns}
      leftPadding={48}
    />
  );
}
